<template>
  <div class="__single-photo-upload">
    <div v-if="value" class="__upload-image" v-loading="isLoading">
      <el-image
        ref="img"
        :src="'/api' + value"
        fit="contain"
        :preview-src-list="['/api' + value]"
      />
      <div class="__image-buttons">
        <i class="el-icon-zoom-in" @click="onPreview"></i>
        <el-popconfirm
          title="确定删除吗？"
          v-if="showDel && !IsDetail"
          @confirm="onDelete"
          @onConfirm="onDelete"
        >
          <i
            class="el-icon-delete"
            slot="reference"
            style="margin-left: 10px"
          ></i>
        </el-popconfirm>
      </div>
    </div>
    <el-upload
      :headers="{ Authorization: 'Bearer ' + token }"
      :action="uploadUrl"
      :before-upload="beforeUpload"
      :on-success="onUploadSuccess"
      :show-file-list="false"
      accept=".jpg,.png,.jpeg"
      :data="data"
    >
      <div class="__upload-area" v-if="!IsDetail" @click="onClick">
        <i class="el-icon-upload2"></i>
      </div>
    </el-upload>
    <div class="t-tip" v-if="tip != ''">
      <span>{{ tip }}</span>
    </div>
  </div>
</template>
<script>
import api from "@/api/common/common";
import * as imageConversion from 'image-conversion'
export default {
  props: {
    value: {
      type: String,
      default: undefined,
    },
    uploadUrl: {
      type: String,
      default: api.uploadPictureUrl,
    },
    deleteFunc: {
      type: Function,
      default: api.deletePhoto,
    },
    type: {
      type: String,
      default: undefined,
    },
    data: {
      type: Object,
      default: null,
    },
    showDel: {
      type: Boolean,
      default: true,
    },
    IsDetail: {
      type: Boolean,
      default: false,
    },
    tip: {
      type: String,
      default: "",
    },
    verifySize: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    // value(nv) {
    //   this.Lvalue = nv;
    // },
  },
  data() {
    return {
      isLoading: false,
      token: this.$commonJs.getCookie("token"),
      // Lvalue: "",
    };
  },
  computed: {
    // fileList() {
    //   if (!this.Lvalue) return [];
    //   return [
    //     {
    //       url: this.Lvalue,
    //     },
    //   ];
    // },
    // header() {
    //   let token = this.$commonJs.getCookie("token");
    //   if (token) {
    //     return { Authorization: "Bearer " + token };
    //   }
    //   return {};
    // },
  },
  methods: {
    onClick() {
      console.log("get_new_token");
      this.token = this.$commonJs.getCookie("token");
    },
    //上传前回调
    beforeUpload(file) {
      if (this.verifySize) {
        var limit = this.$store.state.user.photoSize;
        console.log("size", file.size, file.size / 1024 / 1024);
        // if (limit > 0 && file.size / 1024 / 1024 > limit) {
        //   this.$message.warning("图片大小不能大于" + limit + "MB");
        //   return false;
        // }

        return new Promise((resolve, reject) => {
          let fileTypeLength = file.name.split(".").length;
          if (fileTypeLength > 0) {
            let fileType = file.name
              .split(".")
              [fileTypeLength - 1].toLowerCase();
            const extension = fileType === "jpg";
            const extension2 = fileType === "png";
            const extension4 = fileType === "jpeg";
            const isSizeBig = file.size / 1024 / 1024 < limit; // 图片大小不超过1M
            if (!extension && !extension2 && !extension4) {
              this.$message.warning(
                this.salewaynumber == "en"
                  ? "Pictures can only be in jpg,jpeg,png format"
                  : "上传图片只能是 JPG、JPEG、PNG 格式!"
              );
              //this.isUpload = false;
              reject(false);
            } else {
              // resolve(file)
              if (isSizeBig) {
                resolve(file);
              } else {
                // this.$message.warning(
                //   `当前图片为${(file.size / 1024 / 1024).toFixed(
                //     2
                //   )}M，将进行压缩`
                // );
                imageConversion.compressAccurately(file, 1024).then((res) => {
                  // console.log(res,"aa")
                  // this.$message.warning(
                  //   `压缩完成大小约为${(res.size / 1024 / 1024).toFixed(2)}M`
                  // );
                  resolve(res);                               
                });
              }
            }
          }
        });
      }
    },
    onUploadSuccess(res, file, fileList) {
      // console.log(res);
      this.$emit("input", "" + res.Data);
    },
    onDelete() {
      console.log("?!delete");
      this.$emit("input", "");
      // this.isLoading = true;
      // this.deleteFunc(this.value).then((res) => {
      //   this.isLoading = false;
      //   if (res.Code == 0) {
      //     this.$emit("input", "");
      //   } else {
      //     this.$message.error(res.Msg);
      //   }
      // });
      // this.Lvalue = "";
      this.$emit("delLogo");
    },
    onPreview() {
      this.$refs.img.clickHandler();
    },
  },
};
</script>

<style lang="scss">
.t-tip {
  position: relative;
  width: 200px;
  span {
    left: 8px;
    bottom: 2px;
    position: absolute;
    font-size: 14px;
    color: #909399;
  }
}
.__single-photo-upload {
  display: flex;
  .__upload-area {
    border: 1px dashed #c0ccda;
    // border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    line-height: 120px;
    width: 120px;
    height: 120px;
    font-size: 32px;
    color: #8c939d;
  }
  .__upload-area:hover {
    border-color: #409eff;
  }
  .__upload-image {
    border: 1px solid #c0ccda;
    // border-radius: 6px;
    overflow: hidden;
    width: 120px;
    height: 120px;
    margin-right: 10px;
    position: relative;
    .el-image {
      width: 100%;
      height: 100%;
      // object-fit: cover;
    }
    .__image-buttons {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      bottom: 0;
      opacity: 0;
      background: rgba(0, 0, 0, 0.5);
      line-height: 120px;
      color: #ffffff;
      transition: opacity 0.3s;
      text-align: center;
      i {
        font-size: 18px;
        cursor: pointer;
      }
      i + i {
        margin-left: 10px;
      }
    }
    .__image-buttons:hover {
      opacity: 1;
    }
  }
}
</style>